import StaticSegmentGeneralDetails from './StaticSegmentGeneralDetails';

export default StaticSegmentGeneralDetails;
